import { EventData } from '../../components/calendar-view/types';
import { CalendarEntitySchedule } from './calendar-schedule-definitions';
import { useGetCalendarEventsV3 } from './use-get-calendar-events-v3';

type UseGetOfficeHoursDetailsForCalendarV3ParamsType = {
  schedules: CalendarEntitySchedule[];
  isScheduleDefinitionsEnabled: boolean;
};

export const useGetOfficeHoursDetailsForCalendarV3 = ({
  schedules,
  isScheduleDefinitionsEnabled,
}: UseGetOfficeHoursDetailsForCalendarV3ParamsType) => {
  const { getEntityWorkingHours, getEntityAvailabilityExceptions, getEntityExceptionEvents } = useGetCalendarEventsV3();

  const getOfficeExceptionEventsForCalendarObject = (locationId: string): EventData[] => {
    if (isScheduleDefinitionsEnabled) return [];
    return getEntityExceptionEvents({
      locationId,
      schedules,
      entityId: locationId,
    });
  };

  const getOfficeWorkingHours = (locationId: string) => {
    if (isScheduleDefinitionsEnabled) return [];
    return getEntityWorkingHours({
      schedules,
      locationId,
      entityId: locationId,
    });
  };

  const getOfficeAvailabilityExceptions = (locationId: string): ReturnType<typeof getEntityAvailabilityExceptions> => {
    if (isScheduleDefinitionsEnabled) return { availabilityExceptions: [], isAllDayOff: false };
    return getEntityAvailabilityExceptions({
      locationId,
      schedules,
      entityId: locationId,
    });
  };

  return {
    getOfficeExceptionEventsForCalendarObject,
    getOfficeWorkingHours,
    getOfficeAvailabilityExceptions,
  };
};
